import { API } from '~apis/axios/instance';
import { CardLoginByIdRequest } from '~models/card';

const postConnect = ({
  companyId,
  loginId,
  password,
  organizationCode,
  businessRegNo,
}: CardLoginByIdRequest) => {
  return API.post(`/api/v2/companies/${companyId}/corporate-cards/connect`, {
    data: {
      loginId,
      password,
      organizationCode,
      businessRegNo,
    },
  });
};

export default postConnect;
